import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {FixDates} from "../_decorators/date.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ImplementationControlStatementService {
    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }
  @Load()
  saveImplementationControlStatement(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/implementationControlStatements', result);
  }
  @Load()
  setImplementationControlStatementOrder(order: number[]) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/implementationControlStatements/order', order);
  }
  @Load()
  saveImplementationControlStatementsSet(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/implementationControlStatementSets', result);
  }
  @Load()
  deleteImplementationControlStatementsSet(id: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete<any>(this.config.api + '/api/implementationControlStatementSets/' + id);
  }
  @FixDates()
  getAllImplementationControlStatementSets() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/implementationControlStatementSets');
  }
  @FixDates()
  getAllImplementationControlStatementsFull() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/implementationControlStatements/full');
  }
  @FixDates()
  getAll() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/implementationControlStatements');
  }
  @FixDates()
  getImplementationControlStatement(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/implementationControlStatements/' + id);
  }

  @Load()
  deleteImplementationControlStatement(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/implementationControlStatements/' + id);
  }

  @Load()
  deleteImplementationControlStatements(ids) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post(this.config.api + '/api/implementationControlStatements/multiple', ids);
  }

  @Load()
  uploadItems(entity: File, setId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + '/api/implementationControlStatements/upload/' + setId, formData)
      ;
  }
}
